import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormModelMessage } from '@app/shared/model/form-error-message.model';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { EnvConfigService, SigningRequestChannel } from 'ngx-mat-esign360';

@Component({
  selector: 'app-client-form-card',
  templateUrl: './client-form-card.component.html',
  styleUrls: ['./client-form-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientFormCardComponent implements OnInit {
  @Input() id: number;
  @Input() formGroup: FormGroup;
  @Input() displayClose: boolean;
  @Output() clickClose = new EventEmitter<void>();

  additionalFormErrorMsgs: IFormModelMessage[] = [
    {
      errorId: 'requestChannelContactRequired',
      textI18n: () =>
        this.translate.instant(marker('CLIENT_FORM_CARD.ERRORS.REQ_CHANNEL_CONTACT_REQUIRED')),
    },
    {
      errorId: 'signFieldsContactRequired',
      textI18n: (data) =>
        this.translate.instant(marker('CLIENT_FORM_CARD.ERRORS.SIGN_FIELDS_CONTACT_REQUIRED'), {
          type: data.signatureType,
        }),
    },
  ];

  get signingRequestFormGroup(): FormGroup {
    return this.formGroup.get('signingRequest') as FormGroup;
  }

  get isEmailChannelSelected(): boolean {
    return this.signingRequestFormGroup.get('channel').value === SigningRequestChannel.Email;
  }

  get isChannelSelected(): boolean {
    return this.signingRequestFormGroup.get('channel').value !== SigningRequestChannel.None;
  }

  constructor(public envConfig: EnvConfigService, private translate: TranslateService) {}

  ngOnInit() {}
}
